// none protected routes
export const ROUTE_TWO_FACTOR_AUTHENTICATION = "/authentication/two-factor";
export const ROUTE_HOME = "/";

// protected routes
// exam
export const ROUTE_EXAM_BROAD_SHEET = '/class/:classId/broad-sheet';

// activity
export const ROUTE_ADD_ACTIVITY = '/activity/add';